module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_kimono-560f4db6e0f3387ef67af27b0354b4a4.svg";